import { Link } from 'react-router-dom';

const CHANNELS = ['科技大厂', '互联网与平台', '金融与投行', '消费与零售', '医疗与大健康', '职场观察'];
const ABOUT = [
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/faq' },
  { label: '内容原则', to: '/about#principles' },
  { label: '联系方式', to: '/about#contact' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* 品牌 */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg font-bold text-background-50">
                爆
              </span>
              <span className="flex items-baseline gap-1 font-display text-xl font-bold text-background-50">
                51<span className="text-accent-300">爆料</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-300">
              一个聚焦内部消息与员工爆料的职场信息社区。汇集前员工、知情人士提供的高管动态与职场内幕，坚持匿名投稿、人工核实与理性表达，帮你看清公司真实情况。
            </p>
            <p className="mt-4 text-xs leading-6 text-background-400">
              理性交流，尊重事实。平台内容不构成法律意见，观点归属投稿人，请读者理性判断。
            </p>
          </div>

          {/* 栏目 */}
          <div className="lg:col-span-3">
            <h3 className="text-sm font-bold tracking-wide text-background-50">热门栏目</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {CHANNELS.map((c) => (
                <li key={c}>
                  <Link to="/" className="text-sm text-background-300 transition-colors hover:text-accent-300">
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 导航 */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-bold tracking-wide text-background-50">站点导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {ABOUT.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-background-300 transition-colors hover:text-accent-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 关注 */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-bold tracking-wide text-background-50">更多内容</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-300" aria-hidden="true"></i>
                hi@51baoliao.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-300" aria-hidden="true"></i>
                公众号：51爆料
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-error-warning-line text-accent-300" aria-hidden="true"></i>
                投稿默认匿名
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-700 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © 2026 51爆料 · 打造透明、理性、有温度的职场信息社区
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-accent-300" aria-hidden="true"></i>
              人工核实
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-lock-line text-accent-300" aria-hidden="true"></i>
              投稿匿名保护
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}